import { PortableText } from "@portabletext/react";
import { useEffect, useState } from "react";

const ElSlide = (props) => {
  const { mix,index, activeIndex } = props;

  const [coverPosition, setCoverPosition] = useState("prev");

  useEffect(() => {
    if (activeIndex > index) {
      setCoverPosition("prev");
    } else if (activeIndex < index) {
      setCoverPosition("next");
    } else if (activeIndex === index) {
      setCoverPosition("active");
    }
  }, [activeIndex]);

  return (
    <section className={`home__slide-wrapper`}>
      <div
        className={`home__cover-wrapper editors
            ${coverPosition} home__el`}
      >
        <div className="home__editors-wrapper">
          <h1>Editor's Letter</h1>
          <strong>Gabriel Szatan:</strong>
          <br />
          <br />
          <PortableText value={mix.richText} />
        </div>
        <div className="home__color" />
      </div>
    </section>
  );
};

export default ElSlide;
